import * as constants from './../../constants';
import { save } from './../../utils/local-storage';
import type { SamlAuthorizeOptions } from './types';
import getWebAuth from './utils/getWebAuth';

export default ({ connection }: SamlAuthorizeOptions) => {
  const webAuth = getWebAuth();
  save(constants.localStorage.CONNECTION, connection);
  webAuth.authorize({ connection });
};
